import { render } from "./CreatePays.vue?vue&type=template&id=24acd517"
import script from "./CreatePays.vue?vue&type=script&lang=js"
export * from "./CreatePays.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__